import PopupHideToday from "../../../component/common/popup/PopupHideToday";

const BdExceptionNotice_popup = () => {
    
    return (
        <div className='w-screen h-screen popup_font bg_st_odd'>
            <div className=' flex flex-col pl-1'>
                <h3 className='bg_st_primary py-2 px-4 co_white'>예외전송신청 안내</h3>
                <div className='p-4 flex flex-col gap-1'>
                    <p>
                        1. <span className='co_light_red'>최초전송이 이루어지지 않은</span> 데이터 신청 가능
                    </p>
                    <p>
                        2. <span className='co_light_red'>수정불가</span>(KTAS 수정 등)한 데이터를
                        <span className='co_light_red ml-1'>
                            수정 목적으로 신청하지<span className='bold underline ml-1'>않음</span>
                        </span>
                    </p>
                    <p>
                        3. 예외전송 대상자의
                        <span className='co_light_red mx-1'>
                            응급의료기관코드, 의무기록번호, 내원일시를 반드시 재확인
                        </span>
                        후 신청
                    </p>
                    <p>
                        4. 예외전송 완료된 데이터는 수정, 삭제 불가
                    </p>
                    <p>
                        5. <span className='co_blue'>(이중번호 합번으로 예외전송 신청시)</span>
                        <br/>&emsp;
                        <span className='co_blue'>
                            대상자의 응급의료기관코드, 의무기록번호
                            <span className='co_light_red'>(앞으로 사용하실 의무기록번호)</span>, 내원일자,
                        </span>
                        <br/>&emsp;
                        <span className='co_blue'>
                            <span className='co_light_red'>내원시간(HH24MM)</span>을 반드시 재확인 후 신청
                            <span className='co_light_red'>(내원일시 오후2시10분 → 1410)</span>
                        </span>
                    </p>
                </div>

                <h4 className='bg_tr_primary py-2 px-4 ml-2 co_white w-fit rounded'>데이터 전송 주의사항</h4>
                <div className='py-3 px-4 flex flex-col gap-1'>
                    <p>1. 실제 전송하고자 하는 정보 상태와 불일치
                        <br/>&emsp;- 의무기록번호 / 내원일시 불일치
                        <br/>&emsp;- 대상자 혼동으로 A환자 신청 후 B환자 전송 (오류 발생, 해소 불가)
                    </p>

                    <p>2. 존재하지 않는 환자를 테스트 목적으로 신청하는 경우
                        <br/>&emsp;
                        → 신청 이후 반드시 삭제 요청 <span className='co_blue'>(예외전송 신청 기간 내에 한함)</span>
                    </p>

                    <p>
                        3. <span className='co_light_red'>(이중번호 합번으로 예외전송 시)</span>
                        <br/>&emsp;
                        <span className='co_light_red'>
                            - 의무기록번호(앞으로 사용하실 의무기록번호) / 중증도 분류 선별번호(합번후 삭제되는 번호) 입력 후 재전송
                        </span>
                        <br/>
                    </p>
                    <span className='co_blue'>
                        ※ 신원미상으로 내원한 '무명남(의무기록번호:8765)'을 '홍길동(의무기록번호:1234)'로 합번시
                        <br/>&emsp;
                        재전송하는 선별번호에 반드시 무명남의 의무기록번호:8765)'를 보내야 합번이 가능하며,
                        <br/>&emsp;
                        그렇지 않은 경우 각기 다른 환자로 인식됨
                    </span>
                </div>
                <div className='flex flex-col gap-4 px-6 py-3'>
                    <p className='co_blue'>※ 예외전송신청 마감(목요일 13시) 전까지 삭제 후 재신청 가능</p>
                    <p>문의 : 응급의료평가질향상팀 02-6362-3478</p>
                </div>
            </div>
            <div className='py-4 px-6'>
                <PopupHideToday popupId='bdException' />
            </div>
        </div>
    )
}

export default BdExceptionNotice_popup;